import React from 'react';
import { Stack } from '@mui/material';

import Background from 'components/Questionnaire/common/Background';
import { PageLoader } from 'shared-components/Loaders';

const Loader = () => (
  <Stack
    alignItems='center'
    justifyContent='center'
    width='100%'
    height='100vh'
    sx={{ position: 'relative' }}>
    <Background />
    <PageLoader />
  </Stack>
);

export default Loader;
